module.exports = __webpack_public_path__ + "static/media/activitynote-24.3994982f.svg";